import { Deployment, foldDeployment_ } from "./deployment";
import { I18nContext } from "./i18n";

export type RegionId = string;

export interface RegionR {
  region_id: RegionId;
  name_de: string;
  article_de: string;
  dative_de: string;
  name_en: string;
  article_en: string;
  dative_en: string;
  name_fr: string;
  article_fr: string;
  dative_fr: string;
}

export interface Region {
  key: RegionId;
  name: string;
  article: string;
  dative: string;
}

export function localizeRegion(I18n: I18nContext) {
  return (x: RegionR): Region => ({
    key: x.region_id,
    name: (x as any)[`name_${I18n.locale}`],
    article: (x as any)[`article_${I18n.locale}`],
    dative: (x as any)[`dative_${I18n.locale}`],
  });
}

export function initialRegionsWithDefault(
  deployment: Deployment,
  availableRegions: Array<RegionR>,
  defaultRegion: RegionId,
): Array<RegionId> {
  return foldDeployment_(deployment, {
    ch: () => [],
    de: () => {
      const mbRegion = availableRegions.find((x) => x.region_id === defaultRegion) || availableRegions[0];
      return mbRegion ? [mbRegion.region_id] : [];
    },
  });
}

export function initialRegions(deployment: Deployment, availableRegions: Array<RegionR>): Array<RegionId> {
  return initialRegionsWithDefault(deployment, availableRegions, availableRegions[0].region_id);
}
